import { Images } from "@/assets/images1";
import styles from "./ResidentialIntroStepPage.module.css";

const stepsData = [
  {
    number: 1,
    title: "Property Wear & Tear",
    hint: "Upload photos showing physical damage, wear, or repair needs",
  },
  {
    number: 2,
    title: "Neighborhood Condition",
    hint: "Document neighborhood factors affecting your property value",
  },
  {
    number: 3,
    title: "Sympathy Savings",
    isOptional: true,
    hint: "Provide notes for special circumstances or personal hardships",
  },
  {
    number: 4,
    title: "Review & Submit",
    hint: "Inspect all uploaded documents before final submission",
  },
];

const remindersData = [
  "Upload clear documentation showing property and neighborhood conditions",
  "Take high-quality photos that clearly show any issues or damage",
  "Document both interior and exterior conditions that may affect property value",
  "Include photos of comparable properties in your neighborhood if applicable",
];

export const ResidentialIntroStepPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.heroSection}>
        <div className={styles.mascotBadge}>
          <img
            src={Images.andyHoldingSign}
            alt="Andy holding sign"
            className={styles.mascotImage}
          />
        </div>
        <h3 className={styles.title}>Residential Property Protest Documents Filing Process</h3>
        <p className={styles.description}>
          We&apos;ll guide you through a simple step-by-step process to file your additional or
          supporting property documents.
        </p>
      </div>

      <div className={styles.stepsSection}>
        <div className={styles.stepsGrid}>
          {stepsData.map((step) => (
            <div key={step.number} className={styles.stepCard}>
              <div className={styles.stepNumberBadge}>{step.number}</div>
              <div className={styles.stepContent}>
                <div className={styles.stepTitleRow}>
                  <span className={styles.stepTitle}>{step.title}</span>
                  {step.isOptional && <span className={styles.optionalBadge}>Optional</span>}
                </div>
                <p className={styles.stepHint}>{step.hint}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.remindersCard}>
        <div className={styles.remindersHeader}>
          <div className={styles.remindersIcon} aria-hidden="true">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
          </div>
          <h4 className={styles.remindersTitle}>Important Reminders</h4>
        </div>
        <ul className={styles.remindersList}>
          {remindersData.map((reminder, idx) => (
            <li key={idx} className={reminderItemClass(idx)}>
              <span className={styles.reminderBullet} aria-hidden="true">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </span>
              <span>{reminder}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const reminderItemClass = (_idx: number) => styles.reminderItem;
